// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList,
  StatsGraph
}                         from '../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import { Spinner } from 'react-activity';
import styles      from './style';
import CircularProgress from 'material-ui/CircularProgress';



class RevenueTarget extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    
    this.state = {
      details:{
      venue_id: 'b97a56d4-5742-4a6a-9d03-f4a88c992d21',
      game_id: '1',
      month: 0 ,
      year:0,
      target:0,
      target_name:'Revenue'
      
      },
      venue_list:[],
      game_list:[]

    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    console.log('handleee')
    console.log(event.target.name)
    const name = event.target.name;
    const id = event.target.id;
    var changed_value = event.target.value
    console.log('changed_value')
    console.log(changed_value)
    var new_value =  Object.assign({}, this.state.details);
    new_value[name] = changed_value
    this.setState({details:new_value})    
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
   this.getVenueList(); 
   this.getGameList();

  }

  handleSubmit(event) {

    this.postTargetDetails(this.state.details,this.props);
    console.log('post');
    console.log(this.state);
  }

  postTargetDetails(data,props) {
    console.log('postTargetDetails')
    console.log(data);
    const url = `${getLocationOrigin()}/eagleeye/add_target_details/`;
    const options = {...defaultOptions};
    var formData = new FormData();
    for(var name in data) {
      console.log(name)
      formData.append(name, data[name]);
    }
    options['method'] = 'post';
    options['body'] = formData;
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          console.log('...')
          console.log(response)
          alert(response.message);
          // props.history.goBack();
        })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  getVenueList(){
      const url = `${getLocationOrigin()}/get_venue_list/get_all_active_venues/`;
       const options = {...defaultOptions};
  
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => 
          this.setState({venue_list: data.result}))
         .catch(error => error);
  }

  getGameList(){
       const url = `${getLocationOrigin()}/court/get_games/`;
        const options = {...defaultOptions};
  
       return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => this.setState({game_list:data.results}))
          .catch(error => error);
     }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }




render(){
  console.log('oloo')
  console.log(this.state.game_list)
  console.log(this.state.venue_list)
    return(
      <div style={{...styles.container}}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Add Revenue Target Values</h3>
          </div>
          { this.state.venue_list.length < 1 ?  
            <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}><CircularProgress /></div>
            </div>
          :
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6" >
                Year
              </div>
              <div style = {{width:'50%'}}>
                <textarea style = {{width:'100%'}} rows="1" cols="20" id="year" name="year" onChange={this.handleChange}  value={this.state.details.year}>
                </textarea>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Month
              </div>
              <div style = {{width:'50%'}}>
                <textarea style = {{width:'100%'}} rows="1" cols="20" id="month" name="month" onChange={this.handleChange}  value={this.state.details.month}>
                </textarea>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6" >
                Target Amount
              </div>
              <div style = {{width:'50%'}} >
                <textarea style = {{width:'100%'}} rows="1" cols="20" id="target" name="target" onChange={this.handleChange}  value={this.state.details.target}>
                </textarea>
              </div>
            </div>
            {/*<div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                  Game
              </div>
              <div style = {{width:'50%'}}> 
                    {this.state.game_list.length>0 && 
                <select style = {{width:'100%'}} name="game_id" value={this.state.details.game_id} onChange={this.handleChange}>
                    {
                      this.state.game_list.map((x, index) => (
                      <option key={x.pk} value={x.pk}>{x.game}</option>
                      ))
                    } 
                </select>
                } 
              </div>
            </div>*/}
            <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Venue
                </div>
                <div style = {{width:'50%'}}>
                  {this.state.venue_list.length>0 && 
                  <select style = {{width:'100%'}} name="venue_id" value={this.state.details.venue_id} onChange={this.handleChange}>
                    {
                      this.state.venue_list.map((x, index) => (
                      <option key={x.id} value={x.id}>{x.name}</option>
                      ))
                    } 
                   </select>
                  } 
                </div>
            </div>

            <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Name
                </div>
                <div style = {{width:'50%'}}>
                  <select style = {{width:'100%'}} name="target_name" value={this.state.details.target_name} onChange={this.handleChange}>
                    <option value='Revenue'>Revenue</option>
                    <option value='Collection'>Collection</option>
                  </select>
                </div>
            </div>
            <div style={styles.button_submit} className="col-md-12">
                                    
                  <input className="btn btn-lg"  type="submit" value="Save " style={{
                      backgroundColor:'#302C35',
                      backgroundColor:'#009688',
                      color:'#ffffff'
                  }}/>
            </div>

          </form>
        }
        
        
        </div>
      </div>
    );
  }
}

export default RevenueTarget;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/revenueTarget/RevenueTarget.js